import React, {useContext, useEffect, useState} from 'react';
import {IconButton, makeStyles, Tab, Tabs} from "@material-ui/core";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import Typography from "@material-ui/core/Typography";
import {ArrowDropDown} from "@material-ui/icons";
import TabContent from "./TabContent";
import StylesTemplateMenu from "./StylesTemplate/StylesTemplateMenu";

const useStyles = makeStyles({
    tabsRoot: {
        minHeight: 34
    },
    tabRoot: {
        minWidth: 100,
        padding: 0,
        minHeight: 34,
        textTransform: 'capitalize'
    },
    componentName: {
        textTransform: 'capitalize',
        textAlign: 'center'
    },
    componentEmpty: {
        textAlign: 'center'
    }
});

const tabsSchema = {
    list: ['properties', 'events', 'styles'],
    button: ['properties', 'events', 'styles'],
    field: ['properties', 'events', 'styles'],
    step: ['properties', 'events', 'styles'],
    stepper: ['properties', 'events', 'styles'],
    label: ['properties', 'events', 'styles'],
    image: ['properties', 'events', 'styles'],
    chat: ['properties', 'styles'],
    text: ['properties', 'styles'],
    survey: ['properties', 'styles'],
    embeddedScreen: ['properties', 'styles'],
    fieldArray: ['properties', 'styles'],
    container: ['events', 'styles'],
    tab: ['properties', 'styles'],
    panel: ['styles'],
    line: ['styles'],
    card: ['events', 'styles'],
    tabs: ['properties', 'styles'],
    progress: ['properties', 'styles'],
    selectionCriteria: ['properties', 'events', 'styles'],
    entity: ['properties'],
    context: ['properties', 'styles'],
    feed: ['properties', 'events', 'styles'],
    feedPost: ['properties', 'styles'],
    forEach: ['properties', 'events', 'styles'],
    actionsBar: ['properties'],
    bottomMenu: ['properties', 'styles'],
    navigationItem: ['properties', 'events'],
    maps: ['properties', 'styles'],
    marker: ['properties', 'styles'],
    circle: ['properties', 'styles'],
    checkbox: ['properties', 'events', 'styles'],
    switch: ['properties', 'events', 'styles'],
    dropzone: ['properties', 'events', 'styles'],
    icon: ['properties', 'events', 'styles'],
    searchBar: ['properties', 'styles'],
    header: ['properties', 'events', 'styles'],
    sidebar: ['properties', 'events', 'styles'],
    badge: ['properties', 'events', 'styles'],
    interval: ['properties', 'events'],
    rating: ['properties', 'styles'],
    radioGroup: ['properties', 'events', 'styles'],
    menu: ['properties', 'styles'],
    menuItem: ['properties', 'events', 'styles'],
    band: ['properties', 'styles'],
    block: ['properties', 'events', 'styles'],
    swiper: ['properties', 'styles'],
    swiperItem: ['styles'],
    footer: ['styles'],
    frame: ['styles'],
    accordion: ['properties', 'styles'],
    options: ['properties', 'events', 'styles'],
    fullView: ['properties'],
    serverTime: ['properties', 'styles'],
    dataSource: ['properties'],
    camera: ['styles'],
    pdfReader: ['properties', 'styles'],
    pageBreak: [],
    shortcut: ['properties', 'events'],
    restrictions: ['properties', 'events', 'styles'],
    table: ['properties', 'events', 'styles'],
    tableTd: ['properties', 'styles'],
    tableTh: ['properties', 'styles'],
    tree: ['properties', 'events', 'styles'],
};

const ComponentSettings = () => {
    const {selectedComponent, currentCustomResolution} = useContext(ScreenDesignerContextNew);
    const [component, setComponent] = useState({});
    const [activeTab, setActiveTab] = useState(0);
    const [availableTabs, setAvailableTabs] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const classes = useStyles();

    useEffect(() => {
        if (selectedComponent) {
            const {component: {type} = {}, component = {}} = selectedComponent;
            generateTabContent(type);
            setComponent(component);
        }
    }, [selectedComponent]);

    function generateTabContent(type) {
        const schema = tabsSchema[type] || [];
        if (activeTab > schema.length - 1) {
            setActiveTab(schema.length - 1)
        }
        if (schema.length === 1) {
            setActiveTab(0)
        }
        setAvailableTabs(schema);
    }

    function changeTab(e, value) {
        setActiveTab(value)
    }

    return (
        component.type && tabsSchema[component.type] ? (
            <>
                <Tabs
                    indicatorColor={"primary"}
                    value={activeTab}
                    onChange={changeTab}
                    classes={{root: classes.tabsRoot}}
                    variant={"standard"}
                >
                    {tabsSchema[component.type].map((tab, index) => (
                        <Tab
                            key={index}
                            label={<>
                                {tab === 'styles' ?
                                    <div style={{display: 'flex', alignItems: 'center', padding: "0 5px", width: '100%'}}>
                                        <span style={{whiteSpace: "nowrap", marginRight: 15}}>{currentCustomResolution} styles</span>
                                        <IconButton size={"small"} style={{padding: 0}}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleClick(e)
                                                    }}>
                                            <ArrowDropDown/>
                                        </IconButton>
                                        <StylesTemplateMenu
                                            onClose={handleClose}
                                            anchorEl={anchorEl}
                                        />
                                    </div>
                                    : tab}
                            </>
                            }
                            classes={{root: classes.tabRoot}}
                        />
                    ))}
                </Tabs>
                <TabContent availableTabs={availableTabs} activeTab={activeTab}/>
            </>
        ) : (
            <Typography align={"center"} color={"textSecondary"}>
                Component is not selected
            </Typography>
        )
    )
};

export default ComponentSettings;

